(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-video").modalVideo({
            channel: 'vimeo'
        });

        var swiperHeroSlider = new Swiper('.hero .swiper-hero', {
            navigation: {
                prevEl: '.hero .swiper-button-prev',
                nextEl: '.hero .swiper-button-next',
            },
            autoHeight: true,
        });

        var swiperNewsSlider = new Swiper('.news-slider .swiper-news', {
            navigation: {
                prevEl: '.news-slider .swiper-button-prev',
                nextEl: '.news-slider .swiper-button-next',
            },
            slidesPerView: 3,
            spaceBetween: 30,
            breakpoints: {
                767: {
                    slidesPerView: 2,
                },
                575: {
                    slidesPerView: 1,
                }
            }
        });

        var swiperEsgSlider = new Swiper('.esg-results .swiper-esg', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            slidesPerColumn: 2,
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    slidesPerColumn: 1,
                }
            },
            direction: 'vertical',
            spaceBetween: 30,
            pagination: {
                el: '.swiper-esg .swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<li class="' + className + '" data-index="' + (index + 1) +'"><button><span class="sr-only">Przejdź do slajdu ' + (index + 1) + '</span><span aria-hidden="true">' + 0 + (index + 1) + "</span></button></li>";
                },
            },
            observeParents: true,
            observer: true
        });

        $('.swiper-pagination li').removeAttr('role').removeAttr('aria-label').removeAttr('tabindex');

        function get_hashtag_posts(hashtag, page) {
            console.log(hashtag, page);
            var page = parseInt(page);
            var ppp = 4;
            if (!AJAX_BASE_URL)
                AJAX_BASE_URL = '';
            $.ajax({
                url: AJAX_BASE_URL + "/wp-admin/admin-ajax.php",
                method: "post",
                timeout: 10000,
                data: {
                    action: "get_hashtag_posts",
                    offset: page * ppp,
                    ppp: ppp,
                    hashtag: hashtag
                },
                success: function (data) {
                    $('.hashtag-posts.' + hashtag).append(data);
                    page = page+1;
                    page.toString();
                    $('.hashtags-posts-load-more[data-hashtag="'+ hashtag +'"]').attr('data-page', page);
                },
                error: function () {
                    $('.ajax-info.' + hashtag + ' .loading-error').slideDown();
                },
                beforeSend: function () {
                    $('.ajax-info.' + hashtag + ' .loading-error').slideUp();
                    $('.ajax-info.' + hashtag + ' .loading').slideDown();
                },
                complete: function () {
                    $('.ajax-info.' + hashtag + ' .loading').slideUp();
                },
            });
        }

        //$(document).on('click', '.hashtags-posts-load-more', function () {
        $('.hashtags-posts-load-more').on('click', function () {
            var hashtag = $(this).attr('data-hashtag');
            var page = $(this).attr('data-page');
            get_hashtag_posts(hashtag, page);
        });

    });
}(jQuery));
